import React from 'react'
import Documents from '../../components/forms/Documents'

export default function QuotationDocuments({onBack, onNext}:any) {
  return (
    <Documents
    onBack={onBack} 
    onNext={onNext}
    />
  )
}
